<template>
    <div :class="'d-flex job-offer p-3 ' + fields.type" style="min-height: 85px;">
            <div :class="'offer-type ' + fields.type + ' small'">{{$t(fields.type.capitalize())}}</div>
        <div class="d-inline-block col-12 job-offer-details ">
            <div v-if="fields.title !== ''"><strong>{{$t('Title')}}</strong>: {{fields.title}}</div>
            <div v-if="fields.sector !== ''"><strong>{{$t('Sector')}}</strong>: {{$t(fields.sector)}}</div>
            <div v-if="fields.contract_type !== ''"><strong>{{$t('Contract')}}</strong>: {{$t(fields.contract_type)}}</div>
            <div v-if="fields.country !== ''"><strong>{{$t('Country')}}</strong>: {{countryName}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'countries'],
        data() {
            return {
                fields: {
                    title: '',
                    country: '',
                    type: 'all types',
                    sector: '',
                    contract_type: '',
                    language: '',
                    mode: ''
                }
            }
        },
        computed: {
            countryName: function () {
                return this.countries[this.fields.country]
            }
        },
        mounted() {
            this.fields = Object.assign(this.fields, JSON.parse(this.data.search_params));
        }
    }
</script>
